import React, { useEffect, useRef, useState } from "react";
import { Bot, SendHorizontal, User, Stethoscope } from "lucide-react";
import Navbar from "../components/Navbar";
import axios from "axios";

const NurseChatBot = () => {
  const [messages, setMessages] = useState([
   {0: {
      from: "bot",
      text: "👋 Hello! I’m your Nurse Assistant. Feel free to ask anything about health, care routines, or general wellness.",
    },
    1:{
      from: "bot",
      text: "👋 नमस्ते! मैं आपकी नर्स सहायक हूँ। स्वास्थ्य, देखभाल की दिनचर्या या सामान्य तंदुरुस्ती से जुड़ी कोई भी बात पूछने में संकोच न करें।",
    },
  }
  ]);
  
  const [input, setInput] = useState("");
  const [chat_history, setchat_history] = useState("{}");
  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { from: "user", text: input }];
    setMessages(newMessages);
    setInput("");

    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/medicine_chat",
        {
          message: input,
          session_id: localStorage.getItem("nurse_session_id") || null,
          history: chat_history,
          lang:localStorage.getItem("lang")

        },
        { headers: { "Content-Type": "application/json" } }
      );

      const {
        session_id,
        response: botResponse,
        history_user: updatedChatHistoryFromAPI,
      } = response.data;

      setchat_history(updatedChatHistoryFromAPI);
      localStorage.setItem("nurse_session_id", session_id);

      setMessages((prev) => [
        ...prev,
        { from: "bot", text: botResponse },
      ]);
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-green-50 via-white to-green-100 font-sans">
      <Navbar />

      <div className="flex-grow flex flex-col max-w-3xl mx-auto w-full px-4 sm:px-6 py-6">
        <h2 className="text-4xl font-extrabold text-green-800 mb-6 text-center flex items-center justify-center gap-3 drop-shadow">
          <Stethoscope className="w-7 h-7 text-green-600" /> Nurse Medicine Assistant
        </h2>

        <div
          ref={chatContainerRef}
          className="flex flex-col gap-4 bg-white/80 backdrop-blur-xl p-6 rounded-3xl shadow-xl h-[500px] overflow-y-auto border border-green-200 scrollbar-thin scrollbar-thumb-green-300 scrollbar-track-transparent"
        >
          {messages.map((msg, index) => (
      
            
            <div
              key={index}
            
              className={`flex items-start gap-3 text-sm ${
                msg[localStorage.getItem("lang")].from === "bot" ? "self-start" : "self-end flex-row-reverse"
              }`}
            >
              {console.log(msg)}
              <div className={`rounded-full p-2 shadow-md ${msg[localStorage.getItem("lang")].from === "bot" ? "bg-green-300" : "bg-green-600"}`}>
                {msg[localStorage.getItem("lang")].from === "bot" ? (
                  <Stethoscope className="w-5 h-5 text-white" />
                ) : (
                  <User className="w-5 h-5 text-white" />
                )}
              </div>
              <div
                className={`max-w-[75%] px-4 py-3 rounded-2xl whitespace-pre-wrap leading-relaxed shadow-md ${
                  msg[localStorage.getItem("lang")].from === "bot"
                    ? "bg-gradient-to-r from-green-100 to-green-200 text-green-900"
                    : "bg-gradient-to-r from-green-500 to-green-600 text-white"
                }`}
              >
                {msg[localStorage.getItem("lang")].text}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-3">
          <input
            type="text"
            className="flex-grow px-5 py-3 rounded-full border border-green-300 shadow-lg focus:outline-none focus:ring-2 focus:ring-green-400 transition placeholder:text-green-400 text-green-800"
            placeholder="Ask your nursing or care question..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button
            onClick={handleSend}
            className="bg-green-600 hover:bg-green-700 text-white p-3 rounded-full shadow-lg transition transform hover:scale-110"
          >
            <SendHorizontal className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NurseChatBot;
